// cleanup_convert_to_typescript_file_SMBPYMT

import { sortColumnsByView } from 'components/basicGrid/utils';
import { modifyColumns } from 'components/basicGrid/BasicGrid.staticViews';
import { PAYMENTS_COLUMNS } from 'components/widgets/payments/web/payments.constants';
import { DEFAULT_PER_PAGE, GRID_IDS, ACTIONS_COLUMN } from 'constants.js';

const {
  amount,
  approvedOn,
  approver,
  bankTrace,
  comments,
  confirmationInfo,
  custTrace,
  date,
  fromAccountName,
  fromAccountNumber,
  id,
  initiatedOn,
  initiator,
  payeeName,
  paymentCategory,
  paymentType,
  wirePaymentStatus
} = PAYMENTS_COLUMNS;

const VIEWS = {
  ALL_PAYMENTS: [
    id,
    ACTIONS_COLUMN,
    wirePaymentStatus,
    payeeName,
    fromAccountName,
    fromAccountNumber,
    amount,
    date,
    paymentType,
    paymentCategory,
    approver,
    approvedOn,
    initiator,
    initiatedOn,
    comments,
    bankTrace,
    custTrace,
    confirmationInfo
  ],
  COLLECT_PAYMENTS: [
    id,
    ACTIONS_COLUMN,
    wirePaymentStatus,
    payeeName,
    fromAccountName,
    fromAccountNumber,
    amount,
    date,
    paymentType,
    paymentCategory,
    approver,
    approvedOn,
    initiator,
    initiatedOn,
    comments,
    custTrace
  ],
  REGULAR_PAYMENTS: [
    id,
    ACTIONS_COLUMN,
    wirePaymentStatus,
    payeeName,
    fromAccountName,
    fromAccountNumber,
    amount,
    date,
    paymentType,
    paymentCategory,
    approver,
    approvedOn,
    initiator,
    initiatedOn,
    comments,
    custTrace,
    confirmationInfo
  ],
  REQUIRES_MY_APPROVAL: [
    id,
    ACTIONS_COLUMN,
    wirePaymentStatus,
    payeeName,
    fromAccountName,
    fromAccountNumber,
    amount,
    date,
    paymentType,
    paymentCategory,
    approver,
    approvedOn,
    initiator,
    initiatedOn,
    comments
  ]
};

export const staticViews = ({ active, columnDefs = [], locale }) => {
  const columns = modifyColumns(
    columnDefs?.filter(({ colId }) => ![id, ACTIONS_COLUMN].includes(colId))
  );

  return {
    active,
    views: [
      {
        columns: sortColumnsByView(columns, VIEWS.ALL_PAYMENTS),
        filters: [],
        page: 0,
        pageSize: DEFAULT_PER_PAGE,
        sort: [],
        viewData: {
          id: 1,
          isDefault: true,
          isStatic: true,
          name: locale['payments.allPayments']
        }
      },
      {
        columns: sortColumnsByView(columns, VIEWS.COLLECT_PAYMENTS),
        filters: [
          {
            criteriaDisplay: locale['payments.collectPayments'],
            field: paymentCategory,
            filterData: {
              filter: 'Collect',
              filterType: 'text',
              type: 'contains'
            },
            id: 'paymentCategory-multi-Collect Payments',
            nameDisplay: locale['payments.paymentCategory'],
            operator: 'OR'
          }
        ],
        page: 0,
        pageSize: DEFAULT_PER_PAGE,
        sort: [],
        viewData: {
          id: 2,
          isStatic: true,
          name: locale['payments.collectPayments']
        }
      },
      {
        columns: sortColumnsByView(columns, VIEWS.REGULAR_PAYMENTS),
        filters: [
          {
            criteriaDisplay: locale['payments.regularPayments'],
            field: paymentCategory,
            filterData: {
              filter: 'Regular',
              filterType: 'text',
              type: 'contains'
            },
            id: 'paymentCategory-multi-Regular Payments',
            nameDisplay: locale['payments.paymentCategory'],
            operator: 'OR'
          }
        ],
        page: 0,
        pageSize: DEFAULT_PER_PAGE,
        sort: [],
        viewData: {
          id: 3,
          isStatic: true,
          name: locale['payments.regularPayments']
        }
      },
      {
        columns: sortColumnsByView(columns, VIEWS.REQUIRES_MY_APPROVAL),
        filters: [
          {
            criteriaDisplay: 'Requires My Approval',
            field: wirePaymentStatus,
            filterData: {
              filter: 'Requires my approval',
              filterType: 'text',
              type: 'contains'
            },
            id: 'status-multi-Requires my Approval',
            nameDisplay: locale['common.status'],
            operator: 'OR'
          }
        ],
        page: 0,
        pageSize: DEFAULT_PER_PAGE,
        primary: [amount, date, paymentType, approver],
        sort: [],
        viewData: {
          id: 4,
          isStatic: true,
          name: locale['payments.filter.requiresApproval']
        }
      }
    ]
  };
};

// Updates storage ONLY
// savedViews: 4, still need to be passed along with history.push
// As initial load requires that, because there's no storage created yet at this point.
// --------------------------------------------------------------------------------------------------------------------------
export const changeSimplifiedPaymentStaticView = (user, id, locale = {}) => {
  const storageKey = `${user}-${GRID_IDS.SMALL_BUSINESS_PAYMENTS_GRID}`;
  const smbGridStorage = JSON.parse(sessionStorage.getItem(storageKey));

  if (smbGridStorage) {
    const staticView = staticViews({ locale }).views.find((x) => x.viewData.id === id);
    smbGridStorage.savedViews.active = id;
    smbGridStorage.filters = staticView.filters;

    sessionStorage.setItem(storageKey, JSON.stringify(smbGridStorage));
  }
};
